<div class="header-border">
    <div class="" *ngIf="showHeader">
        <div class="main-content">

            <nav
                class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-light navbar-shadow">

                <div class="navbar-container d-flex content w-100 align-items-center justify-content-between">
                    <div class="pt-50 cursor-pointer ml-2 side-btn">

                    </div>

                    <img src="../../../../assets/images/new cb-small.png" alt="" class="logo-sm responsive-logo ml-0">


                    <div class="nav navbar-nav align-items-center  flexs justify-content-end ">

                        <!-- Mega Menu Trigger -->
                        <div class="menu-trigger-container mx-2">
                            <button (click)="toggleMenu($event)" [class.active-menu]="isMenuOpen"
                                class="btn-menu rounded-circle transition-all">
                                <img src="../../../../assets/images/al-icon.png" alt="Menu" class="menu-img">
                            </button>
                        </div>

                        <div class="h-6 w-px bg-slate-200 ml-2 mr-6 hide-mobile"
                            style="height: 24px; width: 1px; background: #e2e8f0; margin: 0 15px;"></div>

                        <!-- Business Switcher -->
                        <div class="business-switcher" [class.open]="isBusinessMenuOpen"
                            (click)="toggleBusinessMenu($event)">
                            <div class="business-switcher-inner d-flex align-items-center">
                                <div class="business-icon">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-building2 lucide-building-2 text-slate-600"
                                        aria-hidden="true">
                                        <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                                        <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                                        <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                                        <path d="M10 6h4"></path>
                                        <path d="M10 10h4"></path>
                                        <path d="M10 14h4"></path>
                                        <path d="M10 18h4"></path>
                                    </svg>
                                </div>
                                <div class="business-info mx-2">
                                    <span class="business-label">CURRENT BUSINESS</span>
                                    <span class="business-name">{{ getOrgName(orgId) || 'Select Business' }}</span>
                                </div>
                                <div class="business-chevron" [class.rotated]="isBusinessMenuOpen">
                                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <polyline points="6 9 12 15 18 9" stroke="#9ca3af" stroke-width="2.5"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>

                            <!-- Dropdown -->
                            <div class="business-dropdown" *ngIf="isBusinessMenuOpen"
                                (click)="$event.stopPropagation()">
                                <div class="switch-business-header">SWITCH BUSINESS</div>
                                <div class="org-option" *ngFor="let company of companyData"
                                    [class.active]="company?.org_id == orgId"
                                    (click)="setSelectedOrg(company?.org_id, company?.org_name, company?.org_image_link)">
                                    <div class="d-flex align-items-center gap-2 overflow-hidden">
                                        <img [src]="company?.org_image_link" *ngIf="company?.org_image_link"
                                            class="org-option-logo" alt="">
                                        <span class="org-option-name">{{ company?.org_name }}</span>
                                    </div>
                                    <span class="org-active-dot" *ngIf="company?.org_id == orgId"></span>
                                </div>
                            </div>
                        </div>

                        <!-- User Profile -->
                        <div class="user-profile" (click)="toggleProfileMenu($event)">
                            <div class="profile-trigger" [class.open]="isProfileMenuOpen">
                                <span *ngIf="!orgLogo">{{ userInitials }}</span>
                                <img [src]="orgLogo" *ngIf="orgLogo" class="rounded-circle" alt="">
                            </div>

                            <!-- Profile Dropdown -->
                            <div class="profile-menu-dropdown" *ngIf="isProfileMenuOpen"
                                (click)="$event.stopPropagation()">
                                <div class="dropdown-content">
                                    <div class="user-menu-item d-flex align-items-center"
                                        (click)="navigateToMyProfile()">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                                            <circle cx="12" cy="7" r="4"></circle>
                                        </svg>
                                        <span>My Profile</span>
                                    </div>
                                    <div class="user-menu-item d-flex align-items-center"
                                        (click)="redirectToSecurity()">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                                            viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shield"
                                            aria-hidden="true">
                                            <path
                                                d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z">
                                            </path>
                                        </svg>
                                        <span>Security</span>
                                    </div>
                                    <div class="menu-divider"></div>
                                    <div class="user-menu-item d-flex align-items-center"
                                        (click)="redirectToBusinessManagement()">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5v14"></path>
                                        </svg>
                                        <span>Add another company</span>
                                    </div>
                                    <div class="menu-divider"></div>
                                    <div class="user-menu-item sign-out-item d-flex align-items-center"
                                        (click)="logout()">
                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#ef4444"
                                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                                            <polyline points="16 17 21 12 16 7"></polyline>
                                            <line x1="21" y1="12" x2="9" y2="12"></line>
                                        </svg>
                                        <span>Sign Out</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class=" toggle-btn toggle-btn-display">
                            <mat-icon class="burger-menu" (click)="openSidebar()" [ngClass]="{'active': isToggled}"
                                class="">menu</mat-icon>
                        </div>
                    </div>

                </div>
            </nav>
        </div>
    </div>
</div>


<div class="overlay" (click)="closeSidebar()"></div>

<!-- Mega Menu MFE (Web Component) -->
<mega-menu-element *ngIf="isMenuOpen" (close)="onMegaMenuClose()"></mega-menu-element>